var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icofont/geo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements-/-chat-/-nino-image",
    filter: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C12.5128358,0 12.9355072,0.38604019 12.9932723,0.883378875 L13,1 L13.0006955,3.05500569 C17.1720858,3.51645693 20.4841085,6.82877572 20.9451047,11.0003032 L23,11 C23.5522847,11 24,11.4477153 24,12 C24,12.5128358 23.6139598,12.9355072 23.1166211,12.9932723 L23,13 L20.9449943,13.0006955 C20.4835799,17.1717529 17.1717529,20.4835799 13.0006955,20.9449943 L13,23 C13,23.5522847 12.5522847,24 12,24 C11.4871642,24 11.0644928,23.6139598 11.0067277,23.1166211 L11,23 L11.0003032,20.9451047 C6.82877572,20.4841085 3.51645693,17.1720858 3.05500569,13.0006955 L1,13 C0.44771525,13 0,12.5522847 0,12 C0,11.4871642 0.38604019,11.0644928 0.883378875,11.0067277 L1,11 L3.05489527,11.0003032 C3.51592828,6.82844282 6.82844282,3.51592828 11.0003032,3.05489527 L11,1 C11,0.44771525 11.4477153,0 12,0 Z M12,5 C8.13400675,5 5,8.13400675 5,12 C5,15.8659932 8.13400675,19 12,19 C15.8659932,19 19,15.8659932 19,12 C19,8.13400675 15.8659932,5 12,5 Z M12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 Z M12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 Z",
    id: "Combined-Shape",
    fill: "#E20613",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.80bf6591.svg";
export { ForwardRef as ReactComponent };